import { Banner } from "@/components/banner";
import { Button } from "@/components/button";
import { Link } from "@/components/link";

import type { PaymentBannerPlacement } from "./hooks/usePaymentBanners";

import { usePaymentBanners } from "./hooks/usePaymentBanners";

interface PaymentBannersProps {
  readonly placement: PaymentBannerPlacement;
  readonly projectId: number;
}

export function PaymentBanners({ placement, projectId }: PaymentBannersProps) {
  const { banners, canUpdatePaymentMethod, dismiss } = usePaymentBanners(
    projectId,
    placement,
  );

  return banners.map((banner) => {
    const onDismiss = banner.dismissKey ? () => dismiss(banner) : undefined;

    return (
      <Banner
        actions={
          <>
            {onDismiss && (
              <Button
                className="text-sm font-semibold text-button-tertiary-fg hover:text-button-tertiary-fg-hover"
                onPress={onDismiss}
                variant="unstyled"
              >
                Dismiss
              </Button>
            )}
            {canUpdatePaymentMethod ? (
              <Link
                className="text-sm font-semibold text-button-tertiary-color-fg hover:text-button-tertiary-color-fg-hover sm:text-sm"
                href={`/billing/${projectId}/payment-methods`}
              >
                Update payment method
              </Link>
            ) : (
              <p className="text-sm text-text-tertiary">
                Contact your account owner to update the payment method.
              </p>
            )}
          </>
        }
        key={banner.id}
        onClose={onDismiss}
        title={banner.title}
        variant="info"
      >
        <p className="text-sm text-text-tertiary">{banner.message}</p>
      </Banner>
    );
  });
}
